import { Injectable, inject } from '@angular/core';
import { EnvironmentLoaderService } from './environment-loader.service';
import { HttpClient } from '@angular/common/http';
import { QuickSearchResult } from '../components/quick-search/quick-search.model';

@Injectable({
  providedIn: 'root',
})
export class QuickSearchService {
  private environmentLoaderService = inject(EnvironmentLoaderService);
  private httpClient = inject(HttpClient);

  apiUrl: string;
  constructor() {
    this.apiUrl = `${this.environmentLoaderService.config['serviceBaseUrl']}/api/v1/admin/QuickSearch`;
  }

  public search(query: string) {
    return this.httpClient.get<QuickSearchResult[]>(`${this.apiUrl}/${query}`);
  }
}
